import axios from '@/jslib/axios'

export const getSmsLogList= params => {
  return axios({
    method: 'get',
    url: '/admin/code/log',
    params
  })
}

export const getPolicyLogList= (params, other) => {
  return axios({
    method: 'get',
    url: '/admin/policy/all/log',
    params,
    ...other
  })
}
